import * as yup from 'yup';
import { phone as phoneValidator } from 'phone';

yup.addMethod(yup.string, 'validatePhone', function (message, isOptional = false) {
    return this.test('test-phone', message, function (value) {
        if (!value) return true;
        const { options } = this;
        if (isOptional) {
            const isDirty = options?.context?.dirtyFields?.[this.path];
            const isTouched = options?.context?.touchedFields?.[this.path];
            if (!isDirty || !isTouched) return true;
        }

        const { path, createError } = this;
        const val = `+${value}`;

        if (val && !val.startsWith('+')) {
            return createError({ path, message });
        }

        const response = phoneValidator(val, { country: null, validateMobilePrefix: false });
        if (response.isValid && val === response.phoneNumber) return true;
        return createError({ path, message });
    });
});

yup.addMethod(yup.string, 'validateColor', function (message) {
    return this.test('test-color', message, function (value) {
        if (!value) return true;
        const { path, createError } = this;

        if (value && !/^#([a-f0-9]{6}|[a-f0-9]{3})$/gi.test(value)) {
            return createError({ path, message });
        }

        return true;
    });
});
